import tinycolor from 'tinycolor2';

require('../../jquery-plugins/jquery.injectCSS');

const WhiteLabelFactory = function () {};

WhiteLabelFactory.prototype.apply = function () {
  _.each(this.getCssCollection(), $.injectCSS);
  $('header').css('display', 'grid');
};

WhiteLabelFactory.prototype.getCssCollection = function () {
  return this.getCssRules();
};

WhiteLabelFactory.prototype.getTextColorOptions = function () {
  let color = tinycolor('#FFFFFF');
  const colors = [];

  while (color.toHexString() !== '#000000') {
    colors.push(color.toHexString());
    color = color.darken(5);
  }

  return colors;
};

WhiteLabelFactory.prototype.getCssRules = function () {
  const logoImgSmall = INKIVE.C.WHITE_LABEL_CONFIGURATION.logoImgSmall
    ? INKIVE.C.WHITE_LABEL_CONFIGURATION.logoImgSmall
    : INKIVE.C.WHITE_LABEL_CONFIGURATION.logo_url;
  const colors = INKIVE.C.WHITE_LABEL_CONFIGURATION.colors;
  const highlightColor = colors.highlight;

  // TODO: Move this somewhere more sensible
  INKIVE.C.WHITE_LABEL_CONFIGURATION.colors.button = {
    hover: {
      background: tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString(),
      border: highlightColor
    },
    active: {
      background: tinycolor.mix('#FFFFFF', highlightColor, 24).toHexString(),
      border: tinycolor(highlightColor).darken(10).toHexString()
    }
  };

  return [
    logoImgSmall
      ? {
          'body > header': {
            'grid-template-columns': '75px calc(40% - 75px) 60% !important'
          }
        }
      : {},
    logoImgSmall
      ? {
          'body > header .logo-icon > div': {
            background: 'url("' + logoImgSmall + '")no-repeat center center',
            'background-size': 'contain;',
            width: '32px',
            height: '32px'
          }
        }
      : {},
    logoImgSmall
      ? {
          'body > header .menus .back-button-container button.desygner-clear-button[data-action=exit]': {
            display: 'flex'
          }
        }
      : {},
    logoImgSmall
      ? {
          'body > header .menus': {
            'padding-left': '16px'
          }
        }
      : {},
    {
      '#tool-panel #tabTutorial ul li a': {
        color: highlightColor
      }
    },
    {
      '#tool-panel #tabTutorial ul li a:hover': {
        color: tinycolor(highlightColor).darken(10).toHexString()
      }
    },
    {
      '#tool-panel #tabTutorial h1, body > header .ui-dropdown-content h3 > span': {
        color: highlightColor
      }
    },
    {
      'button.btn-primary:hover, button.btn-primary:focus': {
        'background-color': tinycolor(highlightColor).darken(10).toHexString()
      }
    },
    {
      [arrayToCssRule([
        '#try-new-editor:hover',
        '#try-new-editor:focus',
        '.context-menu-root .context-menu-new-editor:hover',
        '.context-menu-root .context-menu-new-editor:focus'
      ])]: {
        background: `${tinycolor(highlightColor).darken(10).toHexString()} !important`
      }
    },
    {
      [arrayToCssRule([
        'button.btn-primary',
        'button.btn-primary:active',
        'button.btn-primary:active icon *',
        '#try-new-editor',
        '.context-menu-root .context-menu-new-editor'
      ])]: {
        background: highlightColor,
        color: '#FFFFFF',
        fill: '#FFFFFF'
      }
    },
    {
      '#tool-panel .tool-content .tab-content.inner-tabs .header-links .header-scroll > div.active::after': {
        'background-color': highlightColor
      }
    },
    {
      '#tool-panel .tool-content #tabSearch .tool-static-block ul li.ui-tabs-active a': {
        color: highlightColor
      }
    },
    {
      '#tool-panel .tool-content .tab-content.text > .add .thumbnail a:hover': {
        color: highlightColor
      }
    },
    {
      '#tool-panel .tool-content .tab-content.text > .add .thumbnail a.applied': {
        color: highlightColor
      }
    },
    {
      '#tool-panel .tool-content .tab-content.text > .library ul.thumbnail-wrapper:not(.folders) >li:hover, #tool-panel .tool-content .tab-content.text .user_library ul.thumbnail-wrapper:not(.folders) >li:focus, #tool-panel .tool-content .tab-content.text > .library ul.thumbnail-wrapper:not(.folders) >li:hover, #tool-panel .tool-content .tab-content.text .user_library ul.thumbnail-wrapper:not(.folders) >li:focus   , .categories-container .category-list .antiscroll-inner .category-element:hover, .categories-container .category-list .antiscroll-inner .category-element:focus': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString() + '!important'
      }
    },
    {
      '#tool-panel .tool-content .tab-content.text > .library ul.thumbnail-wrapper:not(.folders) >li:active, #tool-panel .tool-content .tab-content.text .user_library ul.thumbnail-wrapper:not(.folders) >li:active   , .categories-container .category-list .antiscroll-inner .category-element:active ': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
      }
    },
    {
      '#tool-panel .tool-content .tab-content.inner-tabs .categories-container .category-list .category-element:selected': {
        color: highlightColor
      }
    },
    {
      '#tool-panel .tool-content .tab-content.text > .add .thumbnail .line-container > a.item.active': {
        color: highlightColor
      }
    },
    {
      '#tool-panel .tool-content .tab-content.text > .add .thumbnail .line-container > a a.item:hover': {
        color: highlightColor
      }
    },
    {
      '#tool-panel .tool-content .tab-content.text > .add .thumbnail .line-container a.toggle-options.active': {
        color: highlightColor
      }
    },
    {
      '#tool-panel .tool-content .tab-content.text > .add .thumbnail .options ul li .btn:hover': {
        color: highlightColor
      }
    },
    {
      '#tool-panel #sidebar-resize-button:hover *, #tool-panel #sidebar-resize-button:focus *': {
        color: highlightColor,
        fill: highlightColor
      }
    },
    {
      '#tool-panel .tool-menu ul li.active .btn-tag:after': {
        color: highlightColor + ' !important'
      }
    },
    {
      '.thumbnail-wrapper .thumbnail.image .premium, .template-overlay-list li.hvr-shrink > span .premium-content, .template-overlay-list li.hvr-shrink > span .premium-content ': {
        'background-color': highlightColor
      }
    },
    // .btn-menu

    // Default
    {
      '.modal .content #filter-picker div.ui-tabs-panel': {
        'border-top': '3px solid ' + tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString() + ' !important'
      }
    },
    {
      '.ui-tabs-panel.ui-widget-content.ui-corner-bottom ul.presets-container.slick-initialized.slick-slider span.prev.btn.btn-green.slick-arrow': {
        'background-color': highlightColor
      }
    },
    {
      '.ui-tabs-panel.ui-widget-content.ui-corner-bottom ul.presets-container.slick-initialized.slick-slider span.next.btn.btn-green.slick-arrow': {
        'background-color': highlightColor
      }
    },
    {
      'div.modal ul.btnWrapper.bottom li a#btn-0.btn.btn-modal': {
        'background-color': highlightColor + ' !important'
      }
    },
    {
      'div.modal ul.btnWrapper.bottom li a#btn-0.btn.btn-modal.no-background': {
        'background-color': 'transparent !important'
      }
    },
    {
      '.modal .content #filter-picker ul li.ui-tabs-active a': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString() + ' !important'
      }
    },
    {
      '.ui-dropdown-content[data-id="share"] div.tabs ul.ui-tabs-nav li.ui-state-active':
        {
          'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString() + '! important'
        }
    },
    {
      '.ui-dropdown-content[data-id="share"] div.tabs ul.ui-tabs-nav li.ui-state-active *': {
        color: highlightColor,
        'background-color': 'transparent'
      }
    },
    {
      'a.desygner-clear-button[data-id=shopping-cart], button.desygner-clear-button[data-id=shopping-cart]': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
      }
    },
    {
      'a.modal-header span *, a.modal-header icon *,a.desygner-clear-button[data-id=shopping-cart] icon *, button.desygner-clear-button[data-id=shopping-cart] icon *, a.desygner-clear-button[data-id=shopping-cart] .icon-container *, button.desygner-clear-button[data-id=shopping-cart] .icon-container *': {
        color: highlightColor,
        fill: highlightColor
      }
    },
    {
      '#tool-panel .tool-content .tab-content.inner-tabs .library-link a': {
        'background-color': highlightColor
      }
    },
    {
      '.order-print-options > a.desygner-primary-button, a.btn-modal, a.btn-yellow , a.general-button, button.general-button, div.general-button, a.desygner-primary-button, button.desygner-primary-button, div.desygner-primary-button, a.import-button .button, button.import-button .button, div.import-button .button': {
        'background-color': highlightColor
      }
    },
    {
      '.context-menu-active ': {
        color: highlightColor + '!important'
      }
    },
    {
      '#tool-panel .tool-menu ul li.active a ': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString() + '!important'
      }
    },
    {
      '#tool-panel .tool-menu ul li.active a *': {
        color: highlightColor + '!important',
        fill: highlightColor + '!important'
      }
    },
    {
      '#tool-panel .tool-content .tab-content dt a.btn-accordion': {
        'border-color': highlightColor
      }
    },
    {
      '#tabImages .tab-content .add .antiscroll-inner .import-button div.drag-drop-file': {
        border: '1px solid' + highlightColor + '!important'
      }
    },
    {
      '#tabImages .tab-content .ai-image-cta svg, #tool-panel .tool-content .tab-content .ai-write-cta svg': {
        fill: highlightColor + ' !important'
      }
    },
    {
      '.ui-dropdown-content[data-id="share"] div.tabs div.ui-tabs-panel h3':
        {
          'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
        }
    },
    {
      'body > header .ui-dropdown-content[data-id="order-print"] .order-print-info a[data-action="request-size"]': {
        color: highlightColor
      }
    },

    {
      '#tool-panel .tool-content .tab-content.inner-tabs.logo > .library ul.thumbnail-wrapper:not(.folders) > li > div, #tool-panel .tool-content .tab-content.inner-tabs.icon > .library ul.thumbnail-wrapper:not(.folders) > li > div, #tool-panel .tool-content .tab-content.inner-tabs.logo > .user_library ul.thumbnail-wrapper:not(.folders) > li > div, #tool-panel .tool-content .tab-content.inner-tabs.icon > .user_library ul.thumbnail-wrapper:not(.folders) > li > div': {
        'border-color': highlightColor
      }
    },

    // Selected & hover
    {
      '.ui-tabs-panel.ui-widget-content.ui-corner-bottom ul.presets-container.slick-initialized.slick-slider span.prev.btn.btn-green.slick-arrow:hover, .ui-tabs-panel.ui-widget-content.ui-corner-bottom ul.presets-container.slick-initialized.slick-slider span.prev.btn.btn-green.slick-arrow:focus': {
        'background-color': tinycolor(highlightColor).darken(10).toHexString()
      }
    },
    {
      '.ui-tabs-panel.ui-widget-content.ui-corner-bottom ul.presets-container.slick-initialized.slick-slider span.next.btn.btn-green.slick-arrow:hover, .ui-tabs-panel.ui-widget-content.ui-corner-bottom ul.presets-container.slick-initialized.slick-slider span.next.btn.btn-green.slick-arrow:focus': {
        'background-color': tinycolor(highlightColor).darken(10).toHexString()
      }
    },
    {
      'div.modal ul.btnWrapper.bottom li a#btn-0.btn.btn-modal:hover,div.modal ul.btnWrapper.bottom li a#btn-0.btn.btn-modal:focus': {
        'background-color': tinycolor(highlightColor).darken(10).toHexString() + ' !important'
      }
    },
    {
      'div.modal ul.btnWrapper.bottom li a#btn-0.btn.btn-modal.no-background:hover,div.modal ul.btnWrapper.bottom li a#btn-0.btn.btn-modal.no-background:focus': {
        'background-color': 'transparent !important'
      }
    },
    {
      '.ui-dropdown-content[data-id="share"] div.tabs ul.ui-tabs-nav li.ui-state-default a:hover': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString(),
        color: highlightColor
      }
    },
    {
      ' .ui-dropdown-content[data-id="share"] div.tabs ul.ui-tabs-nav li.ui-state-default a:focus, .ui-dropdown-content[data-id="share"] div.tabs ul.ui-tabs-nav li.ui-corner-top a:focus': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
      }
    },
    {
      'panel#tool-panel div.tool-panel-inner div.tool-content div#tabIcons div.tab-content div.search-container div.search-options div:hover, panel#tool-panel div.tool-panel-inner div.tool-content div#tabIcons div.tab-content div.search-container div.search-options div:focus, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.tab-content div.search-container div.search-options div:hover, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.tab-content.kwls div.search-container div.search-options div:hover, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.tab-content div.add-search-options div.search-options div:hover, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.tab-content.kwls div.add-search-options div.search-options div:hover, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.tab-content div.search-container div.search-options div:focus, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.tab-content.kwls div.search-container div.search-options div:focus,panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.tab-content div.add-search-options div.search-options div:focus, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.tab-content.kwls div.add-search-options div.search-options div:focus': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
      }
    },
    {
      'panel#tool-panel div.tool-panel-inner div.tool-content div#tabIcons div.tab-content div.search-container div.search-options div:hover i,panel#tool-panel div.tool-panel-inner div.tool-content div#tabIcons div.tab-content div.search-container div.search-options div:focus i,panel#tool-panel div.tool-panel-inner div.tool-content div#tabIcons div.tab-content div.search-container div.search-options div:focus span,panel#tool-panel div.tool-panel-inner div.tool-content div#tabIcons div.tab-content div.search-container div.search-options div:hover span,panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.tab-content div.search-container div.search-options div:hover i, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.tab-content div.search-container div.search-options div:focus i, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.tab-content.kwls div.search-container div.search-options div:hover i,panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.tab-content.kwls div.search-container div.search-options div:focus i,panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.tab-content div.add-search-options div.search-options div:hover i,panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.tab-content div.add-search-options div.search-options div:focus i,panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.tab-content.kwls div.add-search-options div.search-options div:hover i,panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.tab-content.kwls div.add-search-options div.search-options div:focus i': {
        color: highlightColor
      }
    },
    {
      '.ui-dropdown-content[data-id="share"] div.tabs ul.ui-tabs-nav li.ui-state-default a:hover * ': {
        color: highlightColor
      }
    },
    {
      '.ui-dropdown-content[data-id="submit-for-review"] div.tabs ul.ui-tabs-nav li.ui-state-default a:hover * ': {
        color: highlightColor
      }
    },
    {
      'div.checkbox-container ul li.filter-line:hover p.desygner-custom-check label .checkmark, div.checkbox-container ul li.filter-line:focus p.desygner-custom-check label .checkmark, div.checkbox-container ul li.filter-line:hover p.desygner-custom-check label .radiomark, div.checkbox-container ul li.filter-line:focus p.desygner-custom-check label .radiomark': {
        'border-color': highlightColor
      }
    },
    {
      '.ui-slider .ui-slider-handle:hover': {
        'background-color': highlightColor,
        'border-color': highlightColor
      }
    },
    {
      '.ui-slider .ui-slider-handle:focus, .ui-slider .ui-slider-handle:active': {
        'border-color': highlightColor,
        'background-color': highlightColor
      }
    },
    {
      'div.checkbox-container ul li.filter-line p.desygner-custom-check label input[type=checkbox]:checked ~ .checkmark, div.checkbox-container ul li.filter-line p.desygner-custom-check label input[type=checkbox]:checked ~ .radiomark:after, div.checkbox-container ul li.filter-line p.desygner-custom-check label input[type=radio]:checked ~ .radiomark:after': {
        'background-color': highlightColor,
        'border-color': highlightColor
      }
    },
    {
      'div.checkbox-container ul li.filter-line:hover p.desygner-custom-check label input[type=checkbox]:checked ~ .checkmark, div.checkbox-container ul li.filter-line:focus p.desygner-custom-check label input[type=checkbox]:checked ~ .radiomark:after, div.checkbox-container ul li.filter-line:hover p.desygner-custom-check label input[type=radio]:checked ~ .radiomark:after': {
        'background-color': tinycolor(highlightColor).darken(10).toHexString(),
        'border-color': tinycolor(highlightColor).darken(10).toHexString()
      }
    },
    {
      'body > header .options .desygner-btn:hover, body > header .options .light-border:hover, div.checkbox-container ul li.filter-line:hover p.desygner-custom-check label input[type=checkbox]:checked ~ .checkmark, div.checkbox-container ul li.filter-line:focus p.desygner-custom-check label input[type=checkbox]:checked ~ .radiomark, div.checkbox-container ul li.filter-line:hover p.desygner-custom-check label input[type=radio]:checked ~ .radiomark': {
        'border-color': tinycolor(highlightColor).darken(10).toHexString()
      }
    },
    {
      'div.checkbox-container ul li.filter-line p.desygner-custom-check label input[type=checkbox]:checked ~ .checkmark, div.checkbox-container ul li.filter-line p.desygner-custom-check label input[type=checkbox]:checked ~ .radiomark, div.checkbox-container ul li.filter-line p.desygner-custom-check label input[type=radio]:checked ~ .radiomark': {
        'border-color': highlightColor
      }
    },
    {
      'div.checkbox-container ul li.filter-line p.desygner-custom-check label input[type=checkbox]:checked ~ .checkmark': {
        background: highlightColor
      }
    },

    {
      '.checkbox-container .filter-line:hover .desygner-custom-check label input[type=checkbox]:checked ~ .checkmark, .checkbox-container .filter-line:focus .desygner-custom-check label input[type=checkbox]:checked ~ .checkmark': {
        'border-color': tinycolor(highlightColor).darken(10).toHexString(),
        'background-color': tinycolor(highlightColor).darken(10).toHexString()
      }
    },
    {
      '.checkbox-container .filter-line .desygner-custom-check label input[type=checkbox]:checked ~ .checkmark, .checkbox-container .filter-line .desygner-custom-check label input[type=checkbox]:checked ~ .checkmark': {
        'border-color': highlightColor,
        'background-color': highlightColor
      }
    },
    {
      'a.btn-yellow:hover, a.btn-yellow:focus, div.import-button .button:hover, div.import-button .button:focus,a.btn-modal:hover,a.btn-modal:focus,a.general-button:hover,button.general-button:hover,div.general-button:hover,a.general-button:focus,button.general-button:focus,div.general-button:focus,.order-print-options > a.desygner-primary-button:hover, .order-print-options > a.desygner-primary-button:focus,a.desygner-primary-button:hover,button.desygner-primary-button:hover,div.desygner-primary-button:hover,a.desygner-primary-button:focus,button.desygner-primary-button:focus,div.desygner-primary-button:focus,a.import-button.button:hover,button.import-button.button:hover,div.import-button.button:hover,a.import-button.button:focus,button.import-button.button:focus,div.import-button.button:focus': {
        'background-color': tinycolor(highlightColor).darken(10).toHexString()
      }
    },
    {
      'div.search-options-container:hover, div.search-options-container:focus, div.filter-button:hover, div.filter-button:focus': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString() + ' !important'
      }
    },
    {
      'panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.search-container div.filter-button:hover icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.search-container div.filter-button:hover icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabImages div.search-container div.filter-button:hover icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabLogos div.search-container div.filter-button:hover icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabIcons div.search-container div.filter-button:hover icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabText div.search-container div.filter-button:hover icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.add-search-options div.filter-button:hover icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.add-search-options div.filter-button:hover icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabImages div.add-search-options div.filter-button:hover icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabLogos div.add-search-options div.filter-button:hover icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabIcons div.add-search-options div.filter-button:hover icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabText div.add-search-options div.filter-button:hover icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.search-container div.filter-button:focus icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.search-container div.filter-button:focus icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabImages div.search-container div.filter-button:focus icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabLogos div.search-container div.filter-button:focus icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabIcons div.search-container div.filter-button:focus icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabText div.search-container div.filter-button:focus icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.add-search-options div.filter-button:focus icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.add-search-options div.filter-button:focus icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabImages div.add-search-options div.filter-button:focus icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabLogos div.add-search-options div.filter-button:focus icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabIcons div.add-search-options div.filter-button:focus icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabText div.add-search-options div.filter-button:focus icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.search-container div.filter-button:hover icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.search-container div.filter-button:hover icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabImages div.search-container div.filter-button:hover icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabLogos div.search-container div.filter-button:hover icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabIcons div.search-container div.filter-button:hover icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabText div.search-container div.filter-button:hover icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.add-search-options div.filter-button:hover icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.add-search-options div.filter-button:hover icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabImages div.add-search-options div.filter-button:hover icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabLogos div.add-search-options div.filter-button:hover icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabIcons div.add-search-options div.filter-button:hover icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabText div.add-search-options div.filter-button:hover icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.search-container div.filter-button:focus icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.search-container div.filter-button:focus icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabImages div.search-container div.filter-button:focus icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabLogos div.search-container div.filter-button:focus icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabIcons div.search-container div.filter-button:focus icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabText div.search-container div.filter-button:focus icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.add-search-options div.filter-button:focus icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.add-search-options div.filter-button:focus icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabImages div.add-search-options div.filter-button:focus icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabLogos div.add-search-options div.filter-button:focus icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabIcons div.add-search-options div.filter-button:focus icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabText div.add-search-options div.filter-button:focus icon *': {
        color: highlightColor + ' !important',
        fill: highlightColor + ' !important'
      }
    },
    {
      'panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.search-container div.search-options-container:hover icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.search-container div.search-options-container:hover icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabImages div.search-container div.search-options-container:hover icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabLogos div.search-container div.search-options-container:hover icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabIcons div.search-container div.search-options-container:hover icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabText div.search-container div.search-options-container:hover icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.add-search-options div.search-options-container:hover icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.add-search-options div.search-options-container:hover icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabImages div.add-search-options div.search-options-container:hover icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabLogos div.add-search-options div.search-options-container:hover icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabIcons div.add-search-options div.search-options-container:hover icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabText div.add-search-options div.search-options-container:hover icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.search-container div.search-options-container:focus icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.search-container div.search-options-container:focus icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabImages div.search-container div.search-options-container:focus icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabLogos div.search-container div.search-options-container:focus icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabIcons div.search-container div.search-options-container:focus icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabText div.search-container div.search-options-container:focus icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.add-search-options div.search-options-container:focus icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.add-search-options div.search-options-container:focus icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabImages div.add-search-options div.search-options-container:focus icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabLogos div.add-search-options div.search-options-container:focus icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabIcons div.add-search-options div.search-options-container:focus icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabText div.add-search-options div.search-options-container:focus icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.search-container div.search-options-container:hover icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.search-container div.search-options-container:hover icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabImages div.search-container div.search-options-container:hover icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabLogos div.search-container div.search-options-container:hover icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabIcons div.search-container div.search-options-container:hover icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabText div.search-container div.search-options-container:hover icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.add-search-options div.search-options-container:hover icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.add-search-options div.search-options-container:hover icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabImages div.add-search-options div.search-options-container:hover icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabLogos div.add-search-options div.search-options-container:hover icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabIcons div.add-search-options div.search-options-container:hover icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabText div.add-search-options div.search-options-container:hover icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.search-container div.search-options-container:focus icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.search-container div.search-options-container:focus icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabImages div.search-container div.search-options-container:focus icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabLogos div.search-container div.search-options-container:focus icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabIcons div.search-container div.search-options-container:focus icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabText div.search-container div.search-options-container:focus icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.add-search-options div.search-options-container:focus icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.add-search-options div.search-options-container:focus icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabImages div.add-search-options div.search-options-container:focus icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabLogos div.add-search-options div.search-options-container:focus icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabIcons div.add-search-options div.search-options-container:focus icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabText div.add-search-options div.search-options-container:focus icon *': {
        color: highlightColor + ' !important',
        fill: highlightColor + ' !important'
      }
    },
    {
      'panel#tool-panel div.tool-panel-inner div.tool-menu ul li a.btn-support:hover icon *': {
        color: highlightColor + ' !important',
        fill: highlightColor + ' !important'
      }
    },

    {
      'a.desygner-clear-button[data-id=order-print]:hover *,button.desygner-clear-button[data-id=order-print]:hover *,div.desygner-clear-button[data-id=order-print]:hover *,a.desygner-clear-button[data-id=order-print]:focus *,button.desygner-clear-button[data-id=order-print]:focus *,div.desygner-clear-button[data-id=order-print]:focus *': {
        color: highlightColor + ' !important',
        fill: highlightColor + ' !important'
      }
    },
    {
      'a.desygner-clear-button[data-id=order-print]:hover,button.desygner-clear-button[data-id=order-print]:hover, div.desygner-clear-button[data-id=order-print]:hover, a.desygner-clear-button[data-id=order-print]:focus,button.desygner-clear-button[data-id=order-print]:focus, div.desygner-clear-button[data-id=order-print]:focus': {
        'border-color': highlightColor + '!important',
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString() + '!important'
      }
    },
    {
      '.checkbox-container li.filter-line:hover, li.checkbox-container .filter-line:focus, a.desygner-clear-button:hover, button.desygner-clear-button:hover, a.desygner-clear-button:focus, button.desygner-clear-button:focus': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString(),
        color: highlightColor
      }
    },
    {
      '.context-menu-root .context-menu-item:hover, .context-menu-root .context-menu-visible:hover, .context-menu-root .context-menu-item:focus, .context-menu-root .context-menu-visible:focus': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
      }
    },
    {
      'a.desygner-clear-button:hover .icon-container *,  button.desygner-clear-button:hover .icon-container *,  a.desygner-clear-button:focus .icon-container *,  button.desygner-clear-button:focus .icon-container *,   a.desygner-clear-button:hover icon *,   button.desygner-clear-button:hover icon *,   a.desygner-clear-button:focus icon *,   button.desygner-clear-button:focus icon *,   a.desygner-clear-button:focus icon *,   button.desygner-clear-button:focus icon *,   a.desygner-clear-button:focus::after ,   button.desygner-clear-button:focus::after,   a.desygner-clear-button:hover::after,   button.desygner-clear-button:hover::after,  a.desygner-clear-button:focus i ,   button.desygner-clear-button:focus i,   a.desygner-clear-button:hover i,   button.desygner-clear-button:hover i': {
        fill: highlightColor,
        color: highlightColor
      }
    },
    {
      'body .modalWrapper .modal .modal-header:hover span  , body .modalWrapper .modal .modal-header:hover icon': {
        fill: highlightColor,
        color: highlightColor
      }
    },
    {
      '#tool-panel .tool-content .tab-content.inner-tabs .library-link a:hover,#tool-panel .tool-content .tab-content.inner-tabs .library-link a:focus ': {
        'background-color': tinycolor(highlightColor).darken(10).toHexString()
      }
    },
    {
      'a.desygner-clear-button[data-id=shopping-cart]:hover, button.desygner-clear-button[data-id=shopping-cart]:hover, a.desygner-clear-button[data-id=shopping-cart]:focus, button.desygner-clear-button[data-id=shopping-cart]:focus': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 24).toHexString()
      }
    },
    {
      'a.desygner-clear-button[data-id=share]:hover, button.desygner-clear-button[data-id=share]:hover, a.desygner-clear-button[data-id=share]:focus, button.desygner-clear-button[data-id=share]:focus': {
        'background-color': tinycolor(highlightColor).darken(10).toHexString() + '!important'
      }
    },
    {
      'button.desygner-clear-button[data-id=share]': {
        'background-color': highlightColor
      },
      'button.desygner-clear-button[data-id=share] span': {
        color: '#FFFFFF !important'
      },
      'button.desygner-clear-button[data-id=share] span:hover': {
        color: '#FFFFFF !important'
      },
      'button.desygner-clear-button[data-id=share] svg *': {
        fill: '#FFFFFF  !important'
      }
    },
    {
      'a.desygner-clear-button[data-id=submit-for-review]:hover, button.desygner-clear-button[data-id=submit-for-review]:hover, a.desygner-clear-button[data-id=submit-for-review]:focus, button.desygner-clear-button[data-id=submit-for-review]:focus': {
        'background-color': tinycolor(highlightColor).darken(10).toHexString() + '!important'
      }
    },
    {
      'button.desygner-clear-button[data-id=submit-for-review]': {
        'background-color': highlightColor,
        color: '#FFFFFF' + ' !important'
      }
    },
    {
      'button.desygner-clear-button[data-id=finish-later]': {
        color: highlightColor,
        border: `1px solid ${highlightColor}`
      }
    },
    {
      'a.desygner-btn[data-id=sharerequest]:hover, button.desygner-btn[data-id=sharerequest]:hover, a.desygner-btn[data-id=sharerequest]:focus, button.desygner-btn[data-id=sharerequest]:focus': {
        'background-color': tinycolor(highlightColor).darken(10).toHexString() + '!important'
      }
    },
    {
      'button.desygner-btn[data-id=sharerequest]': {
        'background-color': highlightColor
      }
    },
    {
      '#tool-panel .tool-content .tab-content.inner-tabs .header-links  div > .name:hover ': {
        color: highlightColor + '!important'
      }
    },
    {
      'body > header .ui-dropdown-content[data-id="order-print"] .order-print-info a[data-action="request-size"]:hover, body > header .ui-dropdown-content[data-id="order-print"] .order-print-info a[data-action="request-size"]:focus ': {
        color: tinycolor(highlightColor).darken(10).toHexString()
      }
    },
    {
      '.ui-dropdown-content[data-id="share"] div.tabs ul.ui-tabs-nav li.ui-state-default a:hover, .ui-dropdown-content[data-id="share"] div.tabs ul.ui-tabs-nav li.ui-corner-top a:hover': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
      }
    },
    {
      '.ui-dropdown-content[data-id="download"] div.tabs ul.ui-tabs-nav li.ui-state-default a:hover  *, .ui-dropdown-content[data-id="share"] div.tabs ul.ui-tabs-nav li.ui-state-default a:hover *, .ui-dropdown-content[data-id="download"] div.tabs ul.ui-tabs-nav li.ui-corner-top a:hover *, .ui-dropdown-content[data-id="share"] div.tabs ul.ui-tabs-nav li.ui-corner-top a:hover *': {
        color: highlightColor,
        fill: highlightColor
      }
    },

    {
      '.tab-content div.version-item:hover, .tab-content div.version-item:focus ,.categories-container .category-list .antiscroll-inner .category-element:hover, .categories-container .category-list .antiscroll-inner .category-element:focus': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString() + '!important',
        color: highlightColor + '!important',
        fill: highlightColor + '!important'
      }
    },
    {
      '.tab-content div.version-item:hover *, .tab-content div.version-item:focus * ': {
        color: highlightColor + '!important',
        fill: highlightColor + '!important'
      }
    },

    // Active
    {
      '.ui-tabs-panel.ui-widget-content.ui-corner-bottom ul.presets-container.slick-initialized.slick-slider span.prev.btn.btn-green.slick-arrow:active': {
        'background-color': tinycolor(highlightColor).darken(10).toHexString()
      }
    }, {
      '.ui-tabs-panel.ui-widget-content.ui-corner-bottom ul.presets-container.slick-initialized.slick-slider span.next.btn.btn-green.slick-arrow:active': {
        'background-color': tinycolor(highlightColor).darken(10).toHexString()
      }
    }, {
      'div.modal ul.btnWrapper.bottom li a#btn-0.btn.btn-modal:active': {
        'background-color': tinycolor(highlightColor).darken(10).toHexString(),
        color: '#FFFFFF' + ' !important'
      }
    },
    {
      'div.modal ul.btnWrapper.bottom li a#btn-0.btn.btn-modal.no-background:active': {
        'background-color': 'none',
        color: 'unset !important'
      }
    },
    {
      '.ui-tabs-panel.ui-widget-content.ui-corner-bottom ul.presets-container.slick-initialized.slick-slider span.prev.btn.btn-green.slick-arrow:active *': {
        color: '#FFFFFF'
      }
    },
    {
      '.ui-tabs-panel.ui-widget-content.ui-corner-bottom ul.presets-container.slick-initialized.slick-slider span.next.btn.btn-green.slick-arrow:active *': {
        color: '#FFFFFF'
      }
    },
    {
      'body > header .options .desygner-btn.light-border:active': {
        'border-color': tinycolor(highlightColor).darken(10).toHexString()
      }
    },
    {
      'body > header .options .desygner-btn.light:active': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 24).toHexString()
      }
    }, {
      'body header div.options button.desygner-btn.light.request.expandable:active': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 24).toHexString() + ' !important'
      }
    }, {
      'body header div.options button.desygner-btn.light.request.expandable:active *': {
        color: highlightColor,
        fill: highlightColor
      }
    },
    {
      'header div.options div.ui-dropdown-content div.tabs.ui-tabs.ui-widget.ui-widget-content.ui-corner-all div#tabs-2.ui-tabs-panel.ui-widget-content.ui-corner-bottom h3': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
      }
    },
    {
      'header div.options div.ui-dropdown-content div.tabs.ui-tabs.ui-widget.ui-widget-content.ui-corner-all ul.ui-tabs-nav.ui-helper-reset.ui-helper-clearfix.ui-widget-header.ui-corner-all li.ui-state-default.ui-corner-top.ui-tabs-active.ui-state-active, header div.options div.ui-dropdown-content div.tabs.ui-tabs.ui-widget.ui-widget-content.ui-corner-all div.ui-tabs-panel.ui-widget-content.ui-corner-bottom h3': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
      }
    },
    {
      'header div.options div.ui-dropdown-content:not(data-id=download) div.tabs.ui-tabs.ui-widget.ui-widget-content.ui-corner-all ul.ui-tabs-nav.ui-helper-reset.ui-helper-clearfix.ui-widget-header.ui-corner-all li.ui-state-default.ui-corner-top.ui-tabs-active.ui-state-active *, header div.options div.ui-dropdown-content div.tabs.ui-tabs.ui-widget.ui-widget-content.ui-corner-all div.ui-tabs-panel.ui-widget-content.ui-corner-bottom h3 *': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
      }
    },
    {
      'html.lato body header div.options div.ui-dropdown-content:not(data-id=download) div.tabs.ui-tabs.ui-widget.ui-widget-content.ui-corner-all ul.ui-tabs-nav.ui-helper-reset.ui-helper-clearfix.ui-widget-header.ui-corner-all li.ui-state-default.ui-corner-top.ui-tabs-active.ui-state-active': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString() + ' !important'
      }
    },
    {
      'header div.options div.ui-dropdown-content:not(data-id=download) div.tabs.ui-tabs.ui-widget.ui-widget-content.ui-corner-all ul.ui-tabs-nav.ui-helper-reset.ui-helper-clearfix.ui-widget-header.ui-corner-all li.ui-state-default.ui-corner-top.ui-tabs-active.ui-state-active *, header div.options div.ui-dropdown-content div.tabs.ui-tabs.ui-widget.ui-widget-content.ui-corner-all div.ui-tabs-panel.ui-widget-content.ui-corner-bottom h3 *': {
        color: highlightColor,
        fill: highlightColor
      }
    },
    {
      '.ui-dropdown-content[data-id="share"] div.tabs ul.ui-tabs-nav li.ui-state-default a:active': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 24).toHexString(),
        color: highlightColor
      }
    },
    {
      '.ui-dropdown-content[data-id="share"] div.tabs ul.ui-tabs-nav li.ui-state-default a:active *':
        {
          color: highlightColor
        }
    },
    {
      'panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.tab-content div.add-search-options div.search-options div:active, panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.tab-content.mls div.add-search-options div.search-options div:active, panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.tab-content.mls div.search-container div.search-options div:active, panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.tab-content div.search-container div.search-options div:hover, panel#tool-panel div.tool-panel-inner div.tool-content div#tabIcons div.tab-content div.search-container div.search-options div:active, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.tab-content div.search-container div.search-options div:active, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.tab-content div.search-container div.search-options div:active,panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.tab-content div.add-search-options div.search-options div:active,panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.tab-content.kwls div.add-search-options div.search-options div:active': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
      }
    },
    {
      'panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.tab-content div.add-search-options div.search-options div:active *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.tab-content.mls div.add-search-options div.search-options div:active *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.tab-content.mls div.search-container div.search-options div:active *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.tab-content div.search-container div.search-options div:hover *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabIcons div.tab-content div.search-container div.search-options div:active *,panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.tab-content div.search-container div.search-options div:active *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.tab-content div.search-container div.search-options div:active *,panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.tab-content div.add-search-options div.search-options div:active *,panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.tab-content.kwls div.add-search-options div.search-options div:active *': {
        color: highlightColor
      }
    },
    {
      'a.btn-yellow:active, div.import-button .button:active, a.btn-modal:active,a.general-button:active,button.general-button:active,div.general-button:active,a.desygner-primary-button:active,button.desygner-primary-button:active,div.desygner-primary-button:active, .order-print-options > a.desygner-primary-button:active, a.import-button.button:active,button.import-button.button:active,div.import-button.button:active': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 24).toHexString(),
        color: highlightColor
      }
    },
    {
      'div.filter-button:active, div.search-options-container:active': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 24).toHexString() + ' !important'
      }
    },
    {
      'panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.search-container div.filter-button:active icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.search-container div.filter-button:active icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabImages div.search-container div.filter-button:active icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabLogos div.search-container div.filter-button:active icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabIcons div.search-container div.filter-button:active icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabText div.search-container div.filter-button:active icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.add-search-options div.filter-button:active icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.add-search-options div.filter-button:active icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabImages div.add-search-options div.filter-button:active icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabLogos div.add-search-options div.filter-button:active icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabIcons div.add-search-options div.filter-button:active icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabText div.add-search-options div.filter-button:active icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.search-container div.filter-button:active icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.search-container div.filter-button:active icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabImages div.search-container div.filter-button:active icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabLogos div.search-container div.filter-button:active icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabIcons div.search-container div.filter-button:active icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabText div.search-container div.filter-button:active icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.add-search-options div.filter-button:active icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.add-search-options div.filter-button:active icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabImages div.add-search-options div.filter-button:active icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabLogos div.add-search-options div.filter-button:active icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabIcons div.add-search-options div.filter-button:active icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabText div.add-search-options div.filter-button:active icon *': {
        color: highlightColor + ' !important',
        fill: highlightColor + ' !important'
      }
    },
    {
      'panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.search-container div.search-options-container:active icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.search-container div.search-options-container:active icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabImages div.search-container div.search-options-container:active icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabLogos div.search-container div.search-options-container:active icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabIcons div.search-container div.search-options-container:active icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabText div.search-container div.search-options-container:active icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.add-search-options div.search-options-container:active icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.add-search-options div.search-options-container:active icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabImages div.add-search-options div.search-options-container:active icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabLogos div.add-search-options div.search-options-container:active icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabIcons div.add-search-options div.search-options-container:active icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabText div.add-search-options div.search-options-container:active icon, panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.search-container div.search-options-container:active icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.search-container div.search-options-container:active icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabImages div.search-container div.search-options-container:active icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabLogos div.search-container div.search-options-container:active icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabIcons div.search-container div.search-options-container:active icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabText div.search-container div.search-options-container:active icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.add-search-options div.search-options-container:active icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.add-search-options div.search-options-container:active icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabImages div.add-search-options div.search-options-container:active icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabLogos div.add-search-options div.search-options-container:active icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabIcons div.add-search-options div.search-options-container:active icon *, panel#tool-panel div.tool-panel-inner div.tool-content div#tabText div.add-search-options div.search-options-container:active icon *': {
        color: highlightColor + ' !important',
        fill: highlightColor + ' !important'
      }
    },
    {
      'a.desygner-clear-button[data-id=order-print]:active *,button.desygner-clear-button[data-id=order-print]:active *,div.desygner-clear-button[data-id=order-print]:active *': {
        color: tinycolor(highlightColor).darken(10).toHexString() + '!important',
        fill: tinycolor(highlightColor).darken(10).toHexString() + '!important'
      }
    },
    {
      'a.desygner-clear-button[data-id=order-print]:active, button.desygner-clear-button[data-id=order-print]:active, div.desygner-clear-button[data-id=order-print]:active': {
        'border-color': tinycolor(highlightColor).darken(10).toHexString() + '!important',
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 24).toHexString() + '!important'
      }
    },
    {
      'a.go-premium:active i, button.go-premium:active i, div.go-premium:active i, a.upgrade:active i, button.upgrade:active i, div.upgrade:active i, a.general-button:active icon *,button.general-button:active icon *, a.desygner-primary-button:active icon * ,button.desygner-primary-button:active icon *, a.desygner-clear-button[data-id="order-print"]:active icon *, button.desygner-clear-button[data-id="order-print"]:active icon *, a.desygner-clear-button[data-id="order-print"]:active *, button.desygner-clear-button[data-id="order-print"]:active *, a.general-button:active icon *': {
        color: highlightColor,
        fill: highlightColor
      }
    },
    {
      'button.desygner-clear-button[data-id=upgrade]': {
        color: highlightColor,
        border: `1px solid ${highlightColor}`
      }
    },
    {
      'button.desygner-clear-button[data-id=upgrade] icon *': {
        color: highlightColor,
        fill: highlightColor
      }
    },
    {
      'a.desygner-clear-button:active, button.desygner-clear-button:active': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 24).toHexString() + '!important',
        color: highlightColor
      }
    },
    {
      '#tool-panel .tool-menu ul li.active a, a.desygner-clear-button[data-action=file]:active': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
      }
    },

    {
      'a.desygner-clear-button[data-id=shopping-cart]:active, button.desygner-clear-button[data-id=shopping-cart]:active': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 24).toHexString()
      }
    },
    {
      '#tool-panel .tool-content .tab-content.inner-tabs .library-link a:active': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 24).toHexString(),
        opacity: '1'
      }
    },
    {
      'body > header .ui-dropdown-content[data-id="order-print"] .order-print-info a[data-action="request-size"]:active': {
        color: tinycolor.mix('#FFFFFF', highlightColor, 24).toHexString()
      }
    },
    {
      'div.tab-content div.version-item:active ,.categories-container .category-list .antiscroll-inner .category-element:active': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 24).toHexString() + '!important',
        color: highlightColor + '!important',
        fill: highlightColor + '!important'
      }
    },

    // Disabled
    {
      '#tool-panel .tool-menu .help-menu-container .help-menu a:hover': {
        color: highlightColor,
        opacity: '1'
      }
    },
    {
      '#tool-panel .tool-content .tab-content.inner-tabs .search-title span, #tool-panel .tool-content .tab-content.inner-tabs .search-title ': {
        'border-bottom': '2px solid ' + highlightColor
      }
    },
    {
      '#login.modal .modal-dialog .modal-content .modal-body button.dsy:not(.social)': {
        'background-color': highlightColor
      }
    },
    {
      'body>header .options .desygner-btn.light.expandable.active': {
        background: highlightColor
      }
    },
    {
      '#tool-panel .tool-content .tab-content .settings-element a.btn-accordion:hover, #tool-panel .tool-content .tab-content dt a.btn-accordion.active, #tool-panel .tool-content .tab-content .settings-element a.btn-accordion.active': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
      }
    },
    {
      'body > header .menus > .back-button-container button:hover, body > header .menus > .back-button-container button.active': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
      }
    },
    {
      'body > header .menus > .back-button-container button span i': {
        color: highlightColor
      }
    },
    {
      'body > header .options .desygner-btn.light:hover, body > header .options .desygner-btn.light:focus': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
      }
    },
    {
      'body header div.options button.desygner-btn.light.request.expandable:hover, body header div.options button.desygner-btn.light.request.expandable:focus': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
      }
    },
    {
      'body header div.options button.desygner-btn.light.request.expandable:hover *, body header div.options button.desygner-btn.light.request.expandable:focus *': {
        color: highlightColor,
        fill: highlightColor
      }
    },
    {
      'body > header .options .desygner-btn.light.active': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 24).toHexString()
      }
    },
    {
      '#tool-panel .tool-content .tab-content.inner-tabs .library ul.thumbnail-wrapper.folders li:hover, #tool-panel .tool-content .tab-content.inner-tabs .library ul.thumbnail-wrapper.folders li.active': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
      }
    },
    {
      'panel#tool-panel div.tool-panel-inner div.tool-content div#tabRestrictions.tab.active div.antiscroll-wrap div.antiscroll-inner div.accordion div.element-restrictions div.group.content div.wrapper dt.restrictions ul.options li.swearing input[type="checkbox"]:checked': {
        'background-color': highlightColor
      }
    },
    {
      'panel#tool-panel div.tool-panel-inner div.tool-content div#tabRestrictions.tab.active div.antiscroll-wrap div.antiscroll-inner div.accordion div.element-restrictions div.group.content div.wrapper dt.restrictions ul.options li.movement input[type="checkbox"]:checked': {
        'background-color': highlightColor
      }
    },
    {
      '.tab-content.restrictions .element-restrictions h4 span, .daterangepicker .ranges button ': {
        background: highlightColor
      }
    },
    {
      '.daterangepicker .ranges button ': {
        background: highlightColor
      }
    },
    {
      '.daterangepicker .ranges button.applyBtn:hover, .daterangepicker .ranges button.applyBtn:focus': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 50).toHexString(),
        color: highlightColor
      }
    },
    {
      '.daterangepicker .ranges button:active ': {
        'background-color': tinycolor(highlightColor).darken(10).toHexString(),
        color: tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
      }
    },
    {
      'panel#tool-panel div.tool-panel-inner div.tool-content div#tabRestrictions.tab.active div.antiscroll-wrap div.antiscroll-inner div.accordion.tab-content.restrictions.active.sub-category div.element-restrictions div.group.content div.wrapper div.restrictions.group ul.options li div.restrictions.group ul.options li ul.typeahead.dropdown-menu li.active': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString() + '!important'
      }
    },
    {
      'div.calendar-table table.table-condensed tbody tr td.available:hover': {
        'background-color': highlightColor,
        color: tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
      }
    },
    {
      'div.calendar-table table.table-condensed tbody tr td.available.active': {
        'background-color': highlightColor,
        color: tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
      }
    },
    {
      'div.calendar-table table.table-condensed thead tr th.next.available:hover *, div.calendar-table table.table-condensed thead tr th.prev.available:hover * ': {
        color: highlightColor,
        fill: highlightColor
      }
    },
    /* popups */
    {
      '.btn-green, .btn-yellow, .btn-red, .btn-primary': {
        background: highlightColor
      }
    },
    {
      '.btn-primary[data-action="table-save"], .btn-modal[id="hf-button-save"], .btn[id="add-to-assets-btn"]': {
        'background-color': highlightColor + '!important'
      }
    },
    {
      '.btn-primary[data-action="table-save"]:hover, .btn-modal[id="hf-button-save"]:hover, .btn[id="add-to-assets-btn"]:hover': {
        'background-color': tinycolor(highlightColor).darken(10).toHexString() + '!important'
      }
    },
    {
      '#element-popupmenu .menu .special-buttons li .radio-btn input:checked + label': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString(),
        'border-color': highlightColor,
        color: highlightColor
      }
    },
    {
      '#element-popupmenu .menu .special-buttons li .radio-btn label:hover': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString(),
        'border-color': highlightColor,
        color: highlightColor
      }
    },
    {
      'ul.ui-tabs-nav li.ui-tabs-active a': {

        border: '3px solid ' + highlightColor,
        'border-bottom': '0'
      }
    },
    {
      'body > header .ui-dropdown-content .ui-tabs-panel': {
        'border-top': '3px solid ' + highlightColor
      }
    },
    {
      '.expand-panel .expand-button, .expand-panel .expand-button.active': {}
    },
    {
      '.expand-panel .expand-button:hover, .expand-panel .expand-button.active:hover': {
        opacity: '1',
        color: highlightColor
      }
    },
    {
      ' .expand-panel.expand-button:hover, .expand-panel.expand-button:active': {
        opacity: '1',
        color: highlightColor
      }
    },

    {
      '.expand-panel .expand-button.active': {
        'font-weight': 'bold'
      }
    },
    {
      '.tab-content.restrictions button.webrand': {
        border: 0
      }
    },
    {
      '.tab-content.restrictions button.webrand:hover': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
      }
    },
    {
      '.tab-content.restrictions button.webrand.selected': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 24).toHexString()
      }
    },
    {
      '.tab-content.restrictions button.webrand.selected *': {
        color: highlightColor
      }
    },
    {
      '#tool-panel .tool-content #tabRestrictions .reset-restrictions button:hover': {
        color: highlightColor + '!important',
        opacity: '1'
      }
    },
    {
      '#tool-panel .tool-content .tab-content .settings-element a.btn-accordion:hover, #tool-panel .tool-content .tab-content .settings-element a.btn-accordion:active': {
        color: highlightColor,
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 24).toHexString()
      }
    },
    {
      '#tool-panel .tool-content #tabRestrictions .reset-restrictions div:hover': {
        color: highlightColor
      }
    },
    {
      'panel#tool-panel div.tool-panel-inner div.tool-content div#tabRestrictions.tab div.accordion div.template-restrictions div.simplified-template-restrictions div.simplified-template-restrictions-option input[type="radio"]:checked': {
        'border-color': highlightColor
      }
    },
    {
      'panel#tool-panel div.tool-panel-inner div.tool-content div#tabRestrictions.tab div.accordion div.template-restrictions div.simplified-template-restrictions div.simplified-template-restrictions-option input[type="radio"]:checked::before': {
        background: highlightColor
      }
    },
    {
      '#tool-panel .tool-content #tabRestrictions .selected-approval': {
        color: highlightColor
      }
    },
    {
      '#tool-panel .tool-content #tabRestrictions .selected-approval-icon': {
        color: highlightColor
      }
    },
    {
      '#tool-panel .tool-content #tabRestrictions .reset-restrictions .active': {
        'border-bottom': '2px solid ' + highlightColor
      }
    },
    {
      '.brand-background-color, .brand-background-color:hover': {
        background: highlightColor
      }
    },

    {
      '.progress-button svg.progress-circle path ': {
        stroke: highlightColor
      }
    },
    {
      '#element-options .content-list .thumbnail:hover': {
        color: highlightColor
      }
    },
    {
      '#element-popupmenu>.menu .ui-dropdown-items .ui-widget-content::after': {
        border: '1px solid ' + highlightColor
      }
    },
    {
      '#element-popupmenu > .menu .ui-dropdown-items .ui-state-default.ui-slider-handle:hover': {
        border: '1px solid ' + highlightColor,
        'box-shadow': `0 0 0 6px ${tinycolor(highlightColor).setAlpha(0.25)}`
      }
    },
    {
      '.element-popupmenu .edit-ordered-list[data-id="edit-ordered-list"] .edit-button': {
        background: highlightColor
      }
    },
    {
      '.element-popupmenu .edit-ordered-list[data-id="edit-ordered-list"] .edit-button:hover': {
        background: tinycolor(highlightColor).darken(10).toHexString()
      }
    },

    {
      '.element-popupmenu .edit-ordered-list[data-id="edit-ordered-list"] .tab-remove-ordered-list div.select-active': {
        'border-color': highlightColor
      }
    },
    {
      '.element-popupmenu .edit-ordered-list[data-id="edit-ordered-list"] .tab-styles div.ordered-style.select-active': {
        'border-color': highlightColor
      }
    },
    {
      '.element-popupmenu .edit-ordered-list[data-id="edit-ordered-list"] .tab-ordered-mark .ordered-mark-container div.ordered-mark.select-active': {
        'border-color': highlightColor
      }
    },
    {
      '.element-popupmenu .edit-ordered-list[data-id="edit-ordered-list"] .tab-remove-ordered-list div:hover': {
        background: tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
      }
    },
    {
      '.element-popupmenu .edit-ordered-list[data-id="edit-ordered-list"] .tab-styles div.ordered-style:hover': {
        background: tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
      }
    },
    {
      '.element-popupmenu .edit-ordered-list[data-id="edit-ordered-list"] .tab-ordered-mark .ordered-mark-container div.ordered-mark:hover': {
        background: tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
      }
    },
    {
      '.element-popupmenu .edit-ordered-list[data-id="edit-ordered-list"] .tab-styles div.ordered-style:hover span': {
        color: highlightColor
      }
    },
    {
      '.element-popupmenu .edit-ordered-list[data-id="edit-ordered-list"] .tab-remove-ordered-list div:hover span': {
        color: highlightColor
      }
    },
    {
      '.element-popupmenu .edit-ordered-list[data-id="edit-ordered-list"] .tab-ordered-mark .ordered-mark-container div.ordered-mark:hover span': {
        color: highlightColor
      }
    },
    {
      '.element-popupmenu .edit-ordered-list[data-id="edit-ordered-list"] .header-container .header .finish-button:hover': {
        color: highlightColor
      }
    },
    {
      '.element-popupmenu .edit-ordered-list[data-id="edit-ordered-list"] .tab-slider .slider input[type="range"]::-webkit-slider-thumb:hover': {
        'border-color': highlightColor,
        'box-shadow': `0 0 0 6px ${tinycolor(highlightColor).setAlpha(0.25)}`
      }
    },
    {
      '.element-popupmenu .edit-ordered-list[data-id="edit-ordered-list"] .tab-slider .slider input[type="range"]::-moz-range-thumb:hover': {
        'border-color': highlightColor,
        'box-shadow': `0 0 0 6px ${tinycolor(highlightColor).setAlpha(0.25)}`
      }
    },
    {
      '.element-popupmenu .edit-bullet-points[data-id="edit-bullet-points"] .edit-button': {
        background: highlightColor
      }
    },
    {
      '.element-popupmenu .edit-bullet-points[data-id="edit-bullet-points"] .edit-button:hover': {
        background: tinycolor(highlightColor).darken(10).toHexString()
      }
    },
    {
      '.element-popupmenu .edit-bullet-points[data-id="edit-bullet-points"] .tab-remove-bullet-points div.select-active': {
        'border-color': highlightColor
      }
    },
    {
      '.element-popupmenu .edit-bullet-points[data-id="edit-bullet-points"] .tab-styles div.bullet-style.select-active': {
        'border-color': highlightColor
      }
    },
    {
      '.element-popupmenu .edit-bullet-points[data-id="edit-bullet-points"] .tab-remove-bullet-points div:hover': {
        background: tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
      }
    },
    {
      '.element-popupmenu .edit-bullet-points[data-id="edit-bullet-points"] .tab-styles div.bullet-style:hover': {
        background: tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
      }
    },
    {
      '.element-popupmenu .edit-bullet-points[data-id="edit-bullet-points"] .tab-styles div.bullet-style:hover span': {
        color: highlightColor
      }
    },
    {
      '.element-popupmenu .edit-bullet-points[data-id="edit-bullet-points"] .tab-remove-bullet-points div:hover span': {
        color: highlightColor
      }
    },
    {
      '.element-popupmenu .edit-bullet-points[data-id="edit-bullet-points"] .header-container .header .finish-button:hover': {
        color: highlightColor
      }
    },
    {
      '.element-popupmenu .edit-bullet-points[data-id="edit-bullet-points"] .tab-slider .slider input[type="range"]::-webkit-slider-thumb:hover': {
        'border-color': highlightColor,
        'box-shadow': `0 0 0 6px ${tinycolor(highlightColor).setAlpha(0.25)}`
      }
    },
    {
      '.element-popupmenu .edit-bullet-points[data-id="edit-bullet-points"] .tab-slider .slider input[type="range"]::-moz-range-thumb:hover': {
        'border-color': highlightColor,
        'box-shadow': `0 0 0 6px ${tinycolor(highlightColor).setAlpha(0.25)}`
      }
    },
    {
      '.bootstrap-tagsinput .tag [data-role=remove]': {
        color: highlightColor
      }
    },
    {
      '.desygner-custom-check label:hover input[type=checkbox] ~ .checkmark, .desygner-custom-check label:hover input[type=radio] ~ .radiomark': {
        border: '1px solid ' + highlightColor
      }
    },
    {
      '.desygner-custom-check label input[type=checkbox]:checked ~ .checkmark, .desygner-custom-check label input[type=radio]:checked ~ .radiomark': {
        'background-color': highlightColor
      }
    },
    {
      '.desygner-custom-check label .checkmark:after, .desygner-custom-check label .radiomark:after': {
        'border-width': '0 3px 3px 0'
      }
    },
    {
      '#tool-panel .tool-content .tab-content > div .tab-content > .item.mns .content .arrow': {
        color: highlightColor
      }
    },
    {
      '#tool-panel .tool-content .tab-content > div .tab-content > .item.kwls .identificator span, #tool-panel .tool-content .tab-content.kwls .kwls-details .antiscroll-wrap .antiscroll-inner .property-details .identificator span': {
        background: highlightColor
      }
    },
    {
      'a.import-button .button, button.import-button .button, div.import-button .button, a.drag-drop-file, button.drag-drop-file, div.drag-drop-file':
        {
          'border-color': highlightColor
        }
    },
    {
      '#tool-panel .tool-content .tab-content > div .tab-content > .item.kwls .button button': {
        border: '2px solid ' + highlightColor,
        color: highlightColor
      }
    },
    {
      '#tool-panel .tool-content .tab-content.kwls .kwls-details .antiscroll-wrap .antiscroll-inner .back-link i': {
        color: highlightColor
      }
    },
    {
      'div#tabKWLS.tab div.tab-content.kwls div.search-container.add-search-options .search-options div:hover, div#tabKWLS.tab div.tab-content.kwls div.search-container.add-search-options .search-options div:focus,div#tabMLS.tab div.tab-content.kwls div.search-container.add-search-options .search-options div:hover, div#tabMLS.tab div.tab-content.kwls div.search-container.add-search-options .search-options div:focus':
        {
          'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
        }
    },
    {
      'div#tabKWLS.tab div.tab-content.kwls div.search-container.add-search-options .search-options div:hover span, div#tabKWLS.tab div.tab-content.kwls div.search-container.add-search-options .search-options div:focus span,div#tabMLS.tab div.tab-content.kwls div.search-container.add-search-options .search-options div:hover span, div#tabMLS.tab div.tab-content.kwls div.search-container.add-search-options .search-options div:focus span': {
        color: highlightColor
      }
    },
    {
      'div#tabKWLS.tab div.tab-content.kwls div.kwls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.back-link span, div#tabMLS.tab.tab div.tab-content.mls div.mls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.back-link span': {
        color: highlightColor
      }
    },
    {
      'div#tabKWLS.tab div.tab-content.kwls div.kwls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.images-header:hover, div#tabMLS.tab div.tab-content.kwls div.kwls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.images-header:focus, div#tabKWLS.tab div.tab-content.mls div.kwls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.images-header:hover, div#tabMLS.tab div.tab-content.mls div.kwls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.images-header:hover, div#tabKWLS.tab div.tab-content.kwls div.mls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.images-header:hover, div#tabMLS.tab div.tab-content.kwls div.mls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.images-header:hover, div#tabKWLS.tab div.tab-content.mls div.mls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.images-header:hover, div#tabMLS.tab div.tab-content.mls div.mls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.images-header:hover, div#tabKWLS.tab div.tab-content.kwls div.kwls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.images-header:hover, div#tabMLS.tab div.tab-content.kwls div.kwls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.images-header:hover, div#tabKWLS.tab div.tab-content.mls div.kwls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.images-header:hover, div#tabMLS.tab div.tab-content.mls div.kwls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.images-header:hover, div#tabKWLS.tab div.tab-content.kwls div.mls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.images-header:hover, div#tabMLS.tab div.tab-content.kwls div.mls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.images-header:hover, div#tabKWLS.tab div.tab-content.mls div.mls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.images-header:hover, div#tabMLS.tab div.tab-content.mls div.mls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.images-header:hover, div#tabKWLS.tab div.tab-content.kwls div.kwls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:hover, div#tabMLS.tab div.tab-content.kwls div.kwls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:hover, div#tabKWLS.tab div.tab-content.mls div.kwls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:hover, div#tabMLS.tab div.tab-content.mls div.kwls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:hover, div#tabKWLS.tab div.tab-content.kwls div.mls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:hover, div#tabMLS.tab div.tab-content.kwls div.mls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:hover, div#tabKWLS.tab div.tab-content.mls div.mls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:hover, div#tabMLS.tab div.tab-content.mls div.mls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:hover, div#tabKWLS.tab div.tab-content.kwls div.kwls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:hover, div#tabMLS.tab div.tab-content.kwls div.kwls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:hover, div#tabKWLS.tab div.tab-content.mls div.kwls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:hover, div#tabMLS.tab div.tab-content.mls div.kwls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:hover, div#tabKWLS.tab div.tab-content.kwls div.mls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:hover, div#tabMLS.tab div.tab-content.kwls div.mls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:hover, div#tabKWLS.tab div.tab-content.mls div.mls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:hover, div#tabMLS.tab div.tab-content.mls div.mls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:hover, div#tabKWLS.tab div.tab-content.kwls div.kwls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.images-header:focus, div#tabMLS.tab div.tab-content.kwls div.kwls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.images-header:focus, div#tabKWLS.tab div.tab-content.mls div.kwls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.images-header:focus, div#tabMLS.tab div.tab-content.mls div.kwls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.images-header:focus, div#tabKWLS.tab div.tab-content.kwls div.mls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.images-header:focus, div#tabMLS.tab div.tab-content.kwls div.mls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.images-header:focus, div#tabKWLS.tab div.tab-content.mls div.mls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.images-header:focus, div#tabMLS.tab div.tab-content.mls div.mls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.images-header:focus, div#tabKWLS.tab div.tab-content.kwls div.kwls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.images-header:focus, div#tabMLS.tab div.tab-content.kwls div.kwls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.images-header:focus, div#tabKWLS.tab div.tab-content.mls div.kwls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.images-header:focus, div#tabMLS.tab div.tab-content.mls div.kwls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.images-header:focus, div#tabKWLS.tab div.tab-content.kwls div.mls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.images-header:focus, div#tabMLS.tab div.tab-content.kwls div.mls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.images-header:focus, div#tabKWLS.tab div.tab-content.mls div.mls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.images-header:focus, div#tabMLS.tab div.tab-content.mls div.mls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.images-header:focus, div#tabKWLS.tab div.tab-content.kwls div.kwls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:focus, div#tabMLS.tab div.tab-content.kwls div.kwls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:focus, div#tabKWLS.tab div.tab-content.mls div.kwls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:focus, div#tabMLS.tab div.tab-content.mls div.kwls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:focus, div#tabKWLS.tab div.tab-content.kwls div.mls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:focus, div#tabMLS.tab div.tab-content.kwls div.mls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:focus, div#tabKWLS.tab div.tab-content.mls div.mls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:focus, div#tabMLS.tab div.tab-content.mls div.mls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:focus, div#tabKWLS.tab div.tab-content.kwls div.kwls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:focus, div#tabMLS.tab div.tab-content.kwls div.kwls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:focus, div#tabKWLS.tab div.tab-content.mls div.kwls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:focus, div#tabMLS.tab div.tab-content.mls div.kwls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:focus, div#tabKWLS.tab div.tab-content.kwls div.mls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:focus, div#tabMLS.tab div.tab-content.kwls div.mls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:focus, div#tabKWLS.tab div.tab-content.mls div.mls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:focus, div#tabMLS.tab div.tab-content.mls div.mls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:focus': {
        color: tinycolor(highlightColor).darken(10).toHexString()
      }
    },
    {
      'div#tabKWLS.tab div.tab-content.kwls div.kwls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:hover, div#tabKWLS.tab div.tab-content.kwls div.kwls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:focus, div#tabMLS.tab div.tab-content.mls div.mls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:hover,div#tabMLS.tab div.tab-content.mls div.mls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.header span.texts-header:focus,div#tabKWLS.tab div.tab-content.kwls div.kwls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.items-content div.texts div.thumbnail-wrapper div.thumbnail a.item:hover, div#tabKWLS.tab div.tab-content.kwls div.kwls div.kwls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.items-content div.texts div.thumbnail-wrapper div.thumbnail a.item:focus, div#tabMLS.tab div.tab-content.mls div.mls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.items-content div.texts div.thumbnail-wrapper div.thumbnail a.item:hover, div#tabMLS.tab div.tab-content.mls div.mls div.mls-details div.antiscroll-wrap.no-resizable div.antiscroll-inner div.items-container div.items-content div.texts div.thumbnail-wrapper div.thumbnail a.item:focus': {
        color: tinycolor(highlightColor).darken(10).toHexString()
      }
    },
    {
      'panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.tab-content div.add-search-options div.search-options div:hover, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.tab-content.kwls div.add-search-options div.search-options div:hover, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.tab-content.kwls div.search-container div.search-options div:hover, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.tab-content div.search-container div.search-options div:hover, panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.tab-content div.add-search-options div.search-options div:hover, panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.tab-content.mls div.add-search-options div.search-options div:hover, panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.tab-content.mls div.search-container div.search-options div:hover, panel#tool-panel div.tool-panel-inner div.tool-content div#tabLS div.tab-content div.search-container div.search-options div:hover, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.tab-content div.add-search-options div.search-options div:focus,panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.tab-content.kwls div.add-search-options div.search-options div:focus, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.tab-content.kwls div.search-container div.search-options div:focus, panel#tool-panel div.tool-panel-inner div.tool-content div#tabKWLS div.tab-content div.search-container div.search-options div:focus, panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.tab-content div.add-search-options div.search-options div:focus, panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.tab-content.mls div.add-search-options div.search-options div:focus, panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.tab-content.mls div.search-container div.search-options div:focus, panel#tool-panel div.tool-panel-inner div.tool-content div#tabMLS div.tab-content div.search-container div.search-options div:focus': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
      }
    },
    {
      '#tool-panel .tool-content .tab-content.kwls .kwls-details .antiscroll-wrap .antiscroll-inner .items-container .header span.active': {
        'border-bottom': '2px solid ' + highlightColor
      }
    },

    {
      '#tool-panel .tool-content .tab-content.kwls .kwls-details .antiscroll-wrap .antiscroll-inner .items-container .items-content .texts .thumbnail-wrapper .icons i': {
        background: highlightColor
      }
    },
    {
      '#tool-panel .tool-content .tab-content > div .tab-content > .item.mns .content .arrow': {
        color: highlightColor
      }
    },
    {
      '#tool-panel .tool-content .tab-content > div .tab-content > .item.mls .identificator span, #tool-panel .tool-content .tab-content.mls .mls-details .antiscroll-wrap .antiscroll-inner .property-details .identificator span': {
        background: highlightColor
      }
    },
    {
      '#tool-panel .tool-content .tab-content > div .tab-content > .item.mls .button button': {
        border: '2px solid ' + highlightColor,
        color: highlightColor
      }
    },
    {
      '#tool-panel .tool-content .tab-content.mls .mls-details .antiscroll-wrap .antiscroll-inner .back-link i': {
        color: highlightColor
      }
    },
    {
      '#tool-panel .tool-content .tab-content.mls .mls-details .antiscroll-wrap .antiscroll-inner .items-container .header span.active': {
        'border-bottom': '2px solid ' + highlightColor
      }
    },
    {
      '#tool-panel .tool-content .tab-content.mls .mls-details .antiscroll-wrap .antiscroll-inner .items-container .items-content .texts .thumbnail-wrapper .icons i': {
        background: highlightColor
      }
    },
    {
      '.ui-slider .ui-slider-handle:hover, .ui-slider .ui-slider-handle:focus': {
        background: highlightColor,
        border: '1px solid ' + highlightColor
      }
    },
    {
      '.modalWrapper .content-LinkknowledgeBase a:hover, .modalWrapper .content-LinkknowledgeBase a:visited': {
        color: highlightColor
      }
    },
    {
      'body > header .options .desygner-btn.light-border:hover': {
        border: '1px solid ' + highlightColor
      }
    },
    {
      '.thumbnail-wrapper.thumbmenu p': {
        color: highlightColor,
        fill: highlightColor
      }
    },
    {
      '#tool-panel .tool-content #tabLayouts li.thumbnail.image > .base .set-size': {
        background: highlightColor
      }
    },
    // WB-7564
    {
      '.page-order-show.desygner-clear-button:hover, .page-order-show.desygner-clear-button:focus ': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
      }
    },
    {
      '.page-order-show.desygner-clear-button:hover *, .page-order-show.desygner-clear-button:focus *': {
        color: highlightColor + ' !important',
        fill: highlightColor + ' !important'
      }
    },
    {
      'div.pages-button-container a.btn.modal-header.page-order-show:active': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 24).toHexString()
      }
    },
    {
      'div.pages-button-container a.btn.modal-header.page-order-show:active *': {
        color: highlightColor + '!important',
        fill: highlightColor + '!important'
      }
    },
    {
      '.page-order-expand.desygner-clear-button:hover, .page-order-expand.desygner-clear-button:focus': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
      }
    },
    {
      'a.page-order-expand.desygner-clear-button:hover div *, a.page-order-expand.desygner-clear-button:focus div *': {
        color: highlightColor,
        fill: highlightColor
      }
    },
    {
      '.page-order-expand.desygner-clear-button:active': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 24).toHexString()
      }
    },
    {
      '.page-order-expand.desygner-clear-button:active *': {
        color: highlightColor,
        fill: highlightColor
      }
    },
    // end WB-7564
    // WB-7709
    {
      '#text-edit  a.text-edit-cancel.button-submenu-clear-border:hover, #text-edit a.text-edit-cancel.button-submenu-clear-border:focus': {
        'border-color': highlightColor,
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString(),
        color: highlightColor
      }
    },
    {
      '#text-edit  a.text-edit-cancel.button-submenu-clear-border:hover *, #text-edit  a.text-edit-cancel.button-submenu-clear-border:focus *': {
        color: highlightColor,
        fill: highlightColor
      }
    },
    {
      '#text-edit  a.text-edit-cancel.button-submenu-clear-border:active': {
        'border-color': highlightColor,
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 24).toHexString(),
        color: highlightColor
      }
    },
    {
      '#text-edit a.text-edit-cancel.button-submenu-clear-border:active *': {
        color: highlightColor,
        fill: highlightColor
      }
    },
    {
      '#text-edit  button.button-submenu-primary': {
        'background-color': highlightColor
      }
    },
    {
      '#text-edit  button.button-submenu-primary:hover, #text-edit button.button-submenu-primary:focus': {
        'background-color': tinycolor(highlightColor).darken(10).toHexString()
      }
    },
    {
      '#text-edit  button.button-submenu-primary:active': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString(),
        color: highlightColor
      }
    },
    {
      '#text-edit button.button-submenu-primary:active *': {
        fill: highlightColor,
        color: highlightColor
      }
    },
    // END 7709
    // WB-7685
    INKIVE.C.IS_WEBRAND
      ? {
          'aside#content.web.landscape panel#bottom-submenu ul.tool-page': {
            position: 'absolute',
            left: '110px'
          }
        }
      : {},
    INKIVE.C.IS_WEBRAND
      ? {
          'aside#content.web.landscape panel#bottom-submenu ul.tool-zoom': {
            position: 'absolute',
            right: '0'
          }
        }
      : {},
    INKIVE.C.IS_WEBRAND
      ? {
          '#bottom-submenu': {
            right: '0',
            'min-width': '430px'
          }
        }
      : {},
    // END WB-7685
    // WB-7721
    {
      'body > header .ui-dropdown-content[data-id="order-print"] div.order-print-options a[data-action="explore-templates"]:hover, body > header .ui-dropdown-content[data-id="order-print"] div.order-print-options a[data-action="download-pdf"]:hover, body > header .ui-dropdown-content[data-id="order-print"] div.order-print-options a[data-action="explore-templates"]:focus, body > header .ui-dropdown-content[data-id="order-print"] div.order-print-options a[data-action="download-pdf"]:focus': {
        'border-color': highlightColor
      }
    },
    {
      'body > header .ui-dropdown-content[data-id="order-print"] div.order-print-options a[data-action="explore-templates"]:active, body > header .ui-dropdown-content[data-id="order-print"] div.order-print-options a[data-action="download-pdf"]:active': {
        'border-color': tinycolor(highlightColor).darken(10).toHexString()
      }
    },
    // END WB-7721
    // WB-7732
    {
      'body .modalWrapper .modal .content #filter-picker div.ui-tabs-panel .slick-arrow.next': {
        'background-color': highlightColor
      }
    },
    {
      'body .modalWrapper .modal .content #filter-picker div.ui-tabs-panel .slick-arrow.prev': {
        'background-color': highlightColor
      }
    },
    {
      'body .modalWrapper .modal .content #filter-picker div.ui-tabs-panel .slick-arrow.next:hover, body .modalWrapper .modal .content #filter-picker div.ui-tabs-panel .slick-arrow.next:focus': {
        'background-color': tinycolor(highlightColor).darken(10).toHexString()
      }
    },
    {
      'body .modalWrapper .modal .content #filter-picker div.ui-tabs-panel .slick-arrow.prev:hover, body .modalWrapper .modal .content #filter-picker div.ui-tabs-panel .slick-arrow.prev:focus': {
        'background-color': tinycolor(highlightColor).darken(10).toHexString()
      }
    },
    {
      'body .modalWrapper .modal .content #filter-picker div.ui-tabs-panel .slick-arrow.next:active': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
      }
    },
    {
      'body .modalWrapper .modal .content #filter-picker div.ui-tabs-panel .slick-arrow.prev:active': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
      }
    },
    {
      'body .modalWrapper .modal .content #filter-picker div.ui-tabs-panel .slick-arrow.next:active i': {
        color: highlightColor
      }
    },
    {
      'body .modalWrapper .modal .content #filter-picker div.ui-tabs-panel .slick-arrow.prev:active i': {
        color: highlightColor
      }
    },
    // END WB-7732
    // WB-7915
    {
      '#bottom-submenu ul.tool-zoom div.ui-dropdown-content.custom-zoom ul li a:hover, #bottom-submenu ul.tool-zoom div.ui-dropdown-content.custom-zoom ul li a:focus': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
      }
    },
    {
      '#bottom-submenu ul.tool-zoom div.ui-dropdown-content.custom-zoom ul li a:active': {
        'background-color': tinycolor.mix('#fff', highlightColor, 24).toHexString()
      }
    },
    // END WB-7915
    // WB-7970
    {
      'button.desygner-clear-button.active': {
        'background-color': tinycolor.mix('#fff', highlightColor, 24).toHexString()
      }
    },
    {
      'button.desygner-clear-button.active icon *': {
        color: highlightColor,
        fill: highlightColor
      }
    },
    // END WB-7970
    // WB-7774
    {
      '.ui-dropdown-content[data-id="versions"] .helper .helper-display .helper-content .btn.go-premium': {
        'background-color': tinycolor.mix('#fff', highlightColor, 10).toHexString()
      }
    },
    {
      '.ui-dropdown-content[data-id="versions"] .helper .helper-display .helper-content .btn.go-premium:hover, .ui-dropdown-content[data-id="versions"] .helper .helper-display .helper-content .btn.go-premium:focus': {
        'background-color': tinycolor.mix('#fff', highlightColor, 15).toHexString()
      }
    },
    {
      '.ui-dropdown-content[data-id="versions"] .helper .helper-display .helper-content .btn.go-premium:active': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 24).toHexString()
      }
    },
    {
      'div[data-id=versions] .helper .helper-display .helper-content .big-icon icon *': {
        fill: highlightColor
      }
    },
    {
      'div.content.active div.antiscroll-wrap div.no-version-saved div.tab-content div.no-version-icon-container icon.no-version-image-layer1': {
        fill: tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
      }
    },
    {
      'div.content.active div.antiscroll-wrap div.no-version-saved div.tab-content div.no-version-icon-container icon.no-version-image-layer2': {
        fill: tinycolor.mix('#FFFFFF', highlightColor, 24).toHexString()
      }
    },
    {
      'div.content.active div.antiscroll-wrap div.no-version-saved div.tab-content div.no-version-icon-container icon.no-version-image-layer3': {
        fill: highlightColor
      }
    },
    {
      'div.content.active div.antiscroll-wrap div.no-version-saved div.tab-content div.no-version-icon-container icon.no-version-image-layer4': {
        fill: highlightColor
      }
    },
    {
      'body > header .ui-dropdown-content[data-id="order-print"] div.order-print-options a[data-action="explore-templates"]:active, body > header .ui-dropdown-content[data-id="order-print"] div.order-print-options a[data-action="download-pdf"]:active': {
        'border-color': tinycolor(highlightColor).darken(10).toHexString()
      }
    },
    // END WB-7774
    // WB-7969
    {
      '#element-popupmenu .menu .common-buttons .editor-add-link-to-text .apply.btn': {
        'background-color': highlightColor
      }
    },
    {
      '#element-popupmenu .menu .common-buttons .editor-add-link-to-text .apply.btn:hover,#element-popupmenu .menu .common-buttons .editor-add-link-to-text .apply.btn:focus': {
        'background-color': tinycolor(highlightColor).darken(10).toHexString()
      }
    },
    {
      '#element-popupmenu .menu .common-buttons .editor-add-link-to-text .apply.btn:active': {
        'background-color': tinycolor.mix('#fff', highlightColor, 24).toHexString(),
        'border-color': tinycolor.mix('#fff', highlightColor, 24).toHexString(),
        color: highlightColor
      }
    },
    {
      '#element-popupmenu .menu .common-buttons .editor-remove-link-to-text .remove.btn:hover, #element-popupmenu .menu .common-buttons .editor-remove-link-to-text .remove.btn:focus': {
        'background-color': tinycolor.mix('#fff', highlightColor, 10).toHexString(),
        'border-color': highlightColor,
        color: highlightColor
      }
    },
    {
      '#element-popupmenu .menu .common-buttons .editor-remove-link-to-text .remove.btn:active': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 24).toHexString(),
        'border-color': highlightColor,
        color: highlightColor
      }
    },
    {
      '#element-popupmenu .menu .common-buttons .editor-remove-link-to-text .remove.btn:hover': {}
    },
    {
      '#element-popupmenu .menu .common-buttons .editor-add-link-to-text .option .filter-line .desygner-custom-check input[type=radio]:checked ~ .radiomark:after': {
        'background-color': highlightColor
      }
    },
    {
      '#element-popupmenu .menu .common-buttons .editor-add-link-to-text .option .filter-line .desygner-custom-check input[type=radio]:checked ~ .radiomark': {
        'border-color': highlightColor
      }
    },
    {
      '#element-popupmenu .menu .common-buttons .editor-remove-link-to-text .option .filter-line .desygner-custom-check input[type=radio]:checked ~ .radiomark': {
        'border-color': highlightColor
      }
    },
    {
      '#element-popupmenu .menu .common-buttons .editor-add-link-to-text .option .filter-line .desygner-custom-check input[name=url]:focus': {
        'border-color': highlightColor
      }
    },
    {
      '#element-popupmenu .menu .common-buttons .editor-add-link-to-text .option .filter-line:hover p.desygner-custom-check label input[type=radio]:checked ~ .radiomark:after,#element-popupmenu .menu .common-buttons .editor-add-link-to-text .option .filter-line:focus p.desygner-custom-check label input[type=radio]:checked ~ .radiomark:after': {
        'background-color': tinycolor(highlightColor).darken(10).toHexString()
      }
    },
    {
      '#element-popupmenu .menu .common-buttons .editor-add-link-to-text .option .filter-line:hover p.desygner-custom-check label input[type=radio]:checked ~ .radiomark,#element-popupmenu .menu .common-buttons .editor-add-link-to-text .option .filter-line:focus p.desygner-custom-check label input[type=radio]:checked ~ .radiomark': {
        'border-color': tinycolor(highlightColor).darken(10).toHexString()
      }
    },
    {
      '#element-popupmenu .menu .common-buttons .editor-add-link-to-text .option .filter-line:hover p.desygner-custom-check label input[type=radio] ~ .radiomark:after, #element-popupmenu .menu .common-buttons .editor-add-link-to-text .option .filter-line:focus p.desygner-custom-check label input[type=radio] ~ .radiomark:after': {
        'background-color': tinycolor(highlightColor).darken(10).toHexString()
      }
    },
    {
      '#element-popupmenu .menu .common-buttons .editor-add-link-to-text .option .filter-line:hover p.desygner-custom-check label input[type=radio] ~ .radiomark, #element-popupmenu .menu .common-buttons .editor-add-link-to-text .option .filter-line:focus p.desygner-custom-check label input[type=radio] ~ .radiomark': {
        'border-color': tinycolor(highlightColor).darken(10).toHexString()
      }
    },
    {
      '#element-popupmenu .menu .common-buttons .editor-add-link-to-text .option .filter-line:active p.desygner-custom-check label input[type=radio]:checked ~ .radiomark:after': {
        'background-color': tinycolor(highlightColor).darken(10).toHexString()
      }
    },
    {
      '#element-popupmenu .menu .common-buttons .editor-add-link-to-text .option .filter-line:active p.desygner-custom-check label input[type=radio] ~ .radiomark': {
        'border-color': tinycolor(highlightColor).darken(10).toHexString()
      }
    },
    // END WB-7969
    // WB-8025
    {
      '.options button.desygner-clear-button:focus': {
        'background-color': 'unset'
      }
    },
    {
      '.options button.desygner-clear-button:focus *': {
        color: '#200E32',
        fill: '#200E32'
      }
    },
    {
      '.options button.desygner-clear-button:active': {
        'background-color': tinycolor.mix('#fff', highlightColor, 24).toHexString()
      }
    },
    {
      '.options button.desygner-clear-button:active *': {
        color: highlightColor,
        fill: highlightColor
      }
    },
    {
      '.options button.desygner-clear-button.active': {
        'background-color': tinycolor.mix('#fff', highlightColor, 10).toHexString()
      }
    },
    {
      '.options button.desygner-clear-button.active *': {
        color: highlightColor,
        fill: highlightColor
      }
    },
    {
      '.options button.desygner-clear-button.ui-dropdown-button:hover': {
        'background-color': tinycolor.mix('#fff', highlightColor, 10).toHexString()
      }
    },
    {
      '.options button.desygner-clear-button.ui-dropdown-button:hover *': {
        color: highlightColor,
        fill: highlightColor
      }
    },
    {
      '.options button.desygner-clear-button.ui-dropdown-button[data-id=shopping-cart]:hover .total.btn': {
        color: '#fff'
      }
    },
    {
      '.menus button.desygner-clear-button:focus': {
        'background-color': 'unset'
      }
    },
    {
      '.menus button.desygner-clear-button:focus *': {
        color: '#200E32',
        fill: '#200E32'
      }
    },
    {
      'body header div.options button.desygner-btn.light.request.expandable:focus': {
        'background-color': 'unset'
      }
    },
    {
      '.options button.desygner-btn.light.request.expandable:focus:focus *': {
        color: '#200E32',
        fill: '#200E32'
      }
    },
    {
      'body header div.options button.desygner-btn.light.request.expandable:active': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 24).toHexString()
      }
    },
    {
      '.options button.desygner-btn.light.request.expandable:focus:active *': {
        color: highlightColor,
        fill: highlightColor
      }
    },
    {
      '.menus button.desygner-clear-button:active': {
        'background-color': tinycolor.mix('#fff', highlightColor, 24).toHexString()
      }
    },
    {
      '.menus button.desygner-clear-button:active *': {
        color: highlightColor,
        fill: highlightColor
      }
    },
    {
      '.menus button.desygner-clear-button.active': {
        'background-color': tinycolor.mix('#fff', highlightColor, 10).toHexString()
      }
    },
    {
      '.menus button.desygner-clear-button.active *': {
        color: highlightColor,
        fill: highlightColor
      }
    },
    {
      '.menus button.desygner-clear-button.ui-dropdown-button:hover': {
        'background-color': tinycolor.mix('#fff', highlightColor, 10).toHexString()
      }
    },
    {
      '.menus button.desygner-clear-button.ui-dropdown-button:hover *': {
        color: highlightColor,
        fill: highlightColor
      }
    },
    // END WB-8025
    // WB-8006
    {
      'button.desygner-clear-button.active span, button.desygner-clear-button.active *': {
        color: highlightColor,
        fill: highlightColor
      }
    },
    // END WB-8006
    // WB-7987
    {
      '#element-popupmenu > .menu .ui-dropdown[data-action="on_fontfamily"] li:hover,#element-popupmenu > .menu .ui-dropdown[data-action="on_fontfamily"] li:focus': {
        'background-color': tinycolor.mix('#fff', highlightColor, 10).toHexString()
      }
    },
    {
      '#element-popupmenu > .menu .ui-dropdown[data-action="on_fontfamily"] li:active': {
        'background-color': tinycolor.mix('#fff', highlightColor, 24).toHexString()
      }
    },
    // END WB-7987
    // WB-7605
    {
      '.linear-progress-root': {
        'background-color': tinycolor.mix('#fff', highlightColor, 10).toHexString()
      }
    },
    {
      '.linear-progress-root .linear-progress-bar': {
        'background-color': highlightColor
      }
    },
    {
      '.linear-progress-root .linear-progress-bar .linear-progress-bar-inner': {
        'border-color': highlightColor
      }
    },
    // END WB-7605
    // EDIT-212
    {
      '#element-popupmenu > .menu .ui-dropdown[data-action="on_fontfamily"] li.selected-font': {
        'background-color': tinycolor.mix('#fff', highlightColor, 24).toHexString()
      }
    },
    // END EDIT-212
    // WB-6989
    {
      '.ui-dropdown-content[data-id="download"] div.tabs ul.ui-tabs-nav li.ui-state-default:hover, .ui-dropdown-content[data-id="share"] div.tabs ul.ui-tabs-nav li.ui-state-default a:hover, .ui-dropdown-content[data-id="download"] div.tabs ul.ui-tabs-nav li.ui-corner-top:hover, .ui-dropdown-content[data-id="share"] div.tabs ul.ui-tabs-nav li.ui-corner-top a:hover': {
        'background-color': tinycolor.mix('#fff', highlightColor, 10).toHexString()
      }
    },
    {
      '.ui-dropdown-content[data-id="download"] div.tabs ul.ui-tabs-nav li.ui-state-default a:hover  *, .ui-dropdown-content[data-id="share"] div.tabs ul.ui-tabs-nav li.ui-state-default a:hover *, .ui-dropdown-content[data-id="download"] div.tabs ul.ui-tabs-nav li.ui-corner-top a:hover *, .ui-dropdown-content[data-id="share"] div.tabs ul.ui-tabs-nav li.ui-corner-top a:hover *': {
        color: highlightColor,
        fill: highlightColor
      }
    },
    {
      '.options .ui-dropdown-content[data-id="download"] .tabs ul.desygner-dropdown-select li.ui-state-default.ui-corner-top.ui-tabs-active.ui-state-active:hover, .options .ui-dropdown-content[data-id="download"] .tabs ul.desygner-dropdown-select li.ui-state-default.ui-corner-top.ui-tabs-active.ui-state-active:focus': {
        'background-color': tinycolor.mix('#fff', highlightColor, 10).toHexString() + '!important'
      }
    },
    {
      '.options .ui-dropdown-content[data-id="download"] .tabs ul.desygner-dropdown-select li.ui-state-default.ui-corner-top.ui-tabs-active.ui-state-active:hover *, .options .ui-dropdown-content[data-id="download"] .tabs ul.desygner-dropdown-select li.ui-state-default.ui-corner-top.ui-tabs-active.ui-state-active:focus *': {
        color: highlightColor,
        fill: highlightColor
      }
    },
    {
      '.options .ui-dropdown-content[data-id="download"] .tabs .desygner-dropdown-select .desygner-dropdown-select-item:hover a span.small, .options .ui-dropdown-content[data-id="download"] .tabs .desygner-dropdown-select .desygner-dropdown-select-item:focus a span.small': {
        color: highlightColor,
        fill: highlightColor
      }
    },
    {
      '#tabs-3 icon:hover, #tabs-3 icon:focus, #tabs-3 icon:hover *, #tabs-3 icon:focus *': {
        color: highlightColor,
        fill: highlightColor
      }
    },
    {
      'div.checkbox-container ul li.filter-line:hover .desygner-custom-check label input[type=checkbox]:checked ~ .radiomark:after': {
        'background-color': highlightColor
      }
    },
    {
      '.options .ui-dropdown-content[data-id="download"] .tabs ul.desygner-dropdown-select li.ui-state-default.ui-corner-top.ui-tabs-active.ui-state-active': {
        'background-color': 'transparent !important'
      }
    },
    {
      '.options .ui-dropdown-content[data-id="download"] .tabs ul.desygner-dropdown-select li.ui-state-default.ui-corner-top.ui-tabs-active.ui-state-active *': {
        color: '#200E32',
        fill: '#200E32'
      }
    },
    {
      '.options .ui-dropdown-content[data-id="download"] .tabs #tabs-1 section#quality-section .slider-container div .quality-slider .ui-slider-handle.ui-state-default.ui-corner-all:active': {
        'border-color': tinycolor(highlightColor).setAlpha(0.5).toRgbString()
      }
    },
    {
      '.options .ui-dropdown-content[data-id="download"] .tabs #tabs-2 section#quality-section .slider-container div .quality-slider .ui-slider-handle.ui-state-default.ui-corner-all:active': {
        'border-color': tinycolor(highlightColor).setAlpha(0.5).toRgbString()
      }
    },
    // END WB-6989
    // EDIT-396
    {
      '.pages-panel .pages-panel-wrapper .pages-panel .content .content-items-wrapper > :first-child > ul .content-item-wrapper[data-active=true] .item .item-preview-wrapper .preview-item': {
        'border-color': highlightColor
      }
    },
    {
      '.pages-panel .pages-panel-wrapper .pages-panel .content .content-items-wrapper > :first-child > ul .content-item-wrapper .item .item-preview-wrapper .preview-item': {
        'border-color': tinycolor.mix('#fff', highlightColor, 10).toHexString()
      }
    },
    {
      '#pages-panel .btn-panel:hover:not(.disabled)': {
        'background-color': tinycolor.mix('#fff', highlightColor, 10).toHexString()
      }
    },
    {
      '#pages-panel .btn-panel:active:not(.disabled)': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 24).toHexString()
      }
    },
    {
      '.pages-panel .pages-panel-wrapper .pages-panel .content .content-items-wrapper > :first-child > ul .content-item-wrapper .item .item-preview-wrapper .preview-item .control .btn-page-options:hover:not(.disabled)': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
      }
    },
    {
      '.pages-panel .pages-panel-wrapper .pages-panel .content .content-items-wrapper > :first-child > ul .content-item-wrapper .item .item-preview-wrapper .preview-item .control.active:not(.disabled) .btn-page-options': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 10).toHexString()
      }
    },
    {
      '.pages-panel .pages-panel-wrapper .pages-panel .content .content-items-wrapper > :first-child > ul .content-item-wrapper .item .item-preview-wrapper .preview-item .control .btn-page-options:hover:not(.disabled)': {
        'background-color': tinycolor.mix('#FFFFFF', highlightColor, 24).toHexString()
      }
    },
    {
      '.pages-panel .pages-panel-wrapper .pages-panel .content .content-items-wrapper > :first-child > ul .content-item-wrapper .item .item-preview-wrapper .preview-item .control.active:not(.disabled) .btn-page-options .dot': {
        'background-color': highlightColor
      }
    },
    {
      '.pages-panel .pages-panel-wrapper .pages-panel .content .content-items-wrapper > :first-child > ul .content-item-wrapper .item .item-preview-wrapper .preview-item .control .btn-page-options:hover:not(.disabled) .dot': {
        'background-color': highlightColor
      }
    },
    {
      '.pages-panel .control-popover .page-options-popover .page-options-wrapper .page-options .page-option:hover:not(.disabled)': {
        'background-color': tinycolor.mix('#fff', highlightColor, 10).toHexString()
      }
    },
    {
      '.pages-panel .control-popover .page-options-popover .page-options-wrapper .page-options .page-option:active:not(.disabled)': {
        'background-color': tinycolor.mix('#fff', highlightColor, 24).toHexString()
      }
    },
    {
      '.pages-panel .pages-panel-wrapper .pages-panel .content .content-items-wrapper > :first-child > ul .content-item-wrapper .item .item-preview-wrapper .preview-item .control .btn-page-options:active:not(.disabled) .dot': {
        'background-color': highlightColor
      }
    },
    {
      '.pages-panel .pages-panel-wrapper .pages-panel .content .content-items-wrapper > :first-child > ul .content-item-wrapper .item .item-preview-wrapper .preview-item .control .btn-page-options:active:not(.disabled)': {
        'background-color': tinycolor.mix('#fff', highlightColor, 24).toHexString()
      }
    },
    // END EDIT-396
    // EDIT-372
    {
      'div.checkbox-container ul li.filter-line:hover p.desygner-custom-check label input[type=checkbox]:checked ~ .radiomark:after, div.checkbox-container ul li.filter-line:focus p.desygner-custom-check label input[type=checkbox]:checked ~ .radiomark:after, div.checkbox-container ul li.filter-line:hover p.desygner-custom-check label input[type=radio]:checked ~ .radiomark:after, div.checkbox-container ul li.filter-line:focus p.desygner-custom-check label input[type=radio]:checked ~ .radiomark:after': {
        'background-color': tinycolor(highlightColor).darken(10).toHexString()
      }
    },
    {
      'div.checkbox-container ul li.filter-line:active p.desygner-custom-check label input[type=checkbox]:checked ~ .radiomark:after, div.checkbox-container ul li.filter-line:focus p.desygner-custom-check label input[type=checkbox]:checked ~ .radiomark:after, div.checkbox-container ul li.filter-line:hover p.desygner-custom-check label input[type=radio]:checked ~ .radiomark:after, div.checkbox-container ul li.filter-line:focus p.desygner-custom-check label input[type=radio]:checked ~ .radiomark:after': {
        'background-color': tinycolor(highlightColor).darken(10).toHexString()
      }
    },
    // END EDIT-372
    // EDIT-397
    {
      '.coach-marks .au-target[ref=rootRef]': {
        'background-color': highlightColor + '!important'
      }
    },
    {
      '.coach-marks .au-target .au-target img': {
        'border-color': highlightColor + '!important'
      }
    },
    {
      '.coach-marks .au-target[ref=arrowRef] polyline': {
        fill: highlightColor + '!important',
        stroke: highlightColor + '!important'
      }
    },
    {
      '.coach-marks button[class*="a__nextButton"] ': {
        color: highlightColor + '!important'
      }
    },
    {
      '.coach-marks button[class*="a__title"], .coach-marks button[class*="a__text"], .coach-marks button[class*="a__skipButton"]  ': {
        color: 'white !important'
      }
    },
    // END EDIT-397
    // EDIT-577
    {
      '#tool-panel .tool-content #tabRedfin > .redfin .redfin .redfin-content .redfin-details .items-container .items-content .texts .thumbnail-wrapper .icons i': {
        background: highlightColor
      }
    },
    {
      '#tool-panel .tool-content #tabRedfin > .redfin .redfin .redfin-content .redfin-details .property-details .identificator span': {
        background: highlightColor
      }
    },
    {
      '#tool-panel .tool-content #tabRedfin > .redfin .redfin .redfin-content .redfin-details .items-container .header span.active': {
        'border-bottom': '2px solid ' + highlightColor
      }
    }
    // END EDIT-577
  ];
};

module.exports = new WhiteLabelFactory();

/**
 * Transform a list of css rules into a string
 * Example: ['.class1', '.class2'] => '.class1, .class2'
 */
function arrayToCssRule (list) {
  return list
    .join(', ');
}
